// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFoundPage_notFoundPage__YA1U1","info":"NotFoundPage_info__bT3rv","buttons":"NotFoundPage_buttons__FubYN"};